import { render } from "./AlertConfig.vue?vue&type=template&id=aee0486c&scoped=true"
import script from "./AlertConfig.vue?vue&type=script&lang=js"
export * from "./AlertConfig.vue?vue&type=script&lang=js"

import "./AlertConfig.vue?vue&type=style&index=0&id=aee0486c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee0486c"]])

export default __exports__